// React Dependencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { Switch } from 'react-router-dom';

// Internal Dependencies
import PrivateRouteAdmin from '../routing/PrivateRoute';
import PoiInfo from './poiInfo';
import Photos from './photos';
import OpeningHoursPage from './openingHours/openingHoursPage';

const Routes = ({ match }) => (
  <Switch>
    <PrivateRouteAdmin exact path={`${match.path}`} component={PoiInfo} />
    <PrivateRouteAdmin exact path={`${match.path}/photos`} component={Photos} />
    <PrivateRouteAdmin exact path={`${match.path}/openinghours`} component={OpeningHoursPage} />
  </Switch>
);

Routes.propTypes = {
  match: PropTypes.shape(Object).isRequired,
};

export default Routes;
